import React from 'react';
import { useTranslation } from 'react-i18next';
import PopupBasic from '../../components/PopupBasic/PopupBasic';
import OpenDetail from "../../components/common/OpenDetail/openDetail";

const Index = ({ data, getObject }) => {
    const { t } = useTranslation();
    return (
        <div className="row">
            <div className="col-xl-12 d-flex">
                <div className="card radius-10 w-100">
                    <div className="card-body">
                        <div className="d-flex align-items-center">
                            <div>
                                <h5 className="mb-1">{t("home.transactionHistory")}</h5>
                                {/* <p className="mb-0 font-13"><i className='bx bxs-calendar'></i>{t("home.last30DaysRevenue")}
                                </p> */}
                            </div>
                        </div>
                        <div className="table-responsive mt-4 custom-scroll">
                            <table className="table align-middle mb-0 table-hover" id="Transaction-History">
                                <thead className="table-light">
                                    <tr>
                                        <th>{t("properties.amount")}</th>
                                        <th>{t("properties.status")}</th>
                                        <th>{t("properties.rental_cabinet_sn_home")}</th>
                                        <th>{t("properties.created_at")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data.map((obj) => (
                                            <tr key={obj.id}>
                                                <td>{obj?.amount}</td>
                                                <td>
                                                    {
                                                        obj?.status ?
                                                            <span className="badge bg-success">{obj?.status_name}</span> :
                                                            <span className="badge bg-danger">{obj?.status_name}</span>
                                                    }
                                                </td>
                                                <td>{obj?.order?.rental_cabinet_sn}</td>
                                                <td>{obj?.order?.created_at}</td>
                                                <td>
                                                    <OpenDetail
                                                        text={t("properties.cabinetDetails")}
                                                        editState={getObject(obj)}
                                                    />
                                                    {/* <div className="badge rounded-pill bg-light text-white w-100" data-bs-toggle="modal" data-bs-target="#exampleScrollableModal">Detail</div> */}
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <PopupBasic text="Sifariş Detalları" />
        </div>
    )
}

export default React.memo(Index)